import type { ElementAnimationStyle } from '@adflow/utils';
import { FC } from 'react';

type Props = {
  svgString: string;
  animationStyle?: ElementAnimationStyle;
  animationTargetId?: string;
};

const SVGElement: FC<Props> = ({ svgString = '', animationStyle, animationTargetId }) => {
  return (
    <div
      data-animation-target-id={animationTargetId}
      style={
        animationStyle
          ? { transform: animationStyle.transform, opacity: animationStyle.opacity }
          : undefined
      }
      dangerouslySetInnerHTML={{ __html: svgString }}
    />
  );
};

SVGElement.displayName = 'SVGElement';

export default SVGElement;
